import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
import { useNavigate, useOutletContext } from "react-router-dom";
import { parseAndSetFlag } from "utils/Utils";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
const UploadedBtKit = ({
  setNext,
  setBack,
  loanApplicationId,
  classes,
  closeModal,
  status,
  featureFlags,
  loanType,
  prePledgeLoan,
  btKitEsign,
  esignDisableBtKit, 
  setEsignDisableBtKit,
}) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const navigate = useNavigate();
  const [message, setMessage]= useState('');
  const [preview, setPreView] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
    const outletData = featureFlags;
    const multiEsignBtLetterEnabled = parseAndSetFlag(outletData?.enabledMutliSignBtLetter)
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const mutliEsignEndPoint =  endpoint.BT_KIT_GET_ESIGN_LETTER;
   useEffect(() => {
     if(btKitEsign && !esignDisableBtKit){
       const interval = setInterval(async () => {
         const res = await apiHandler({
           url: mutliEsignEndPoint + loanApplicationId,
           method: "GET",
           authToken: authToken,
         });
         setCallInProgress(false);
         if ((res?.data?.status === "DONE" || res?.data?.status === "COMPLETED") && res?.data?.fileLink) {
           setPreView(res?.data?.fileLink)
           clearInterval(interval);
           setEsignDisableBtKit(false)
         } else if(res?.data?.status === "REJECTED"){
            setMessage("Your Sanction Letter is Rejected. Please Esign Again");
           setEsignDisableBtKit(false)
           clearInterval(interval);
         }
       },10000);
       return () => {
         clearInterval(interval);
       };
     }else{
       GetSanctionLetter();
     }
   }, []);
  const handleNext = () => {
    setNext();
  };
  const handleBack = () => {
    setBack();
  };

  const GetSanctionLetter = async () => {
    //SANCTION_LETTER
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.btLoanLetterLink || res?.data?.esignBtLetter) {
      setPreView(res?.data?.esignBtLetter || res?.data?.btLoanLetterLink);
    } else {
      toastUpdate("Error","BT loan letter link not upload against this loan", true);
    }
  };
  const onClickProceedData = async (id) => {
    setCallInProgress(true);
     if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
      if(checkResult?.data?.error_code){
        toastUpdate("Error",checkResult?.data?.user_description,true);
        return;
      }else{
               const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(id)) || [];
         if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
  }
    const result = await apiHandler({
      url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        navigate("/loanservice/disbursLms", { state: { from: '' } });
    }
  };
  const proceedApplication = () => {
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg(
      "Are you sure you want to Proceed this Loan to LMS"
    );
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };
  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete loanMarking
    onClickProceedData(loanApplicationId);
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={6} sm={6} md={6} lg={6} style={{ textAlign: "start" }}>
           <SubHeader
                      label="Esign" />
        </GridItem>
      </GridContainer>
      <hr />
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer>
             <GridItem xs={12} sm={12} md={12} lg={12}>
                     {preview ? <iframe src={preview} width="100%" height="500px" />
                     :
                     <GridItem
                     xs={12}
                     sm={12}
                     md={12}
                     lg={12}
                     style={{
                       textAlign: "center",
                       marginTop: 50,
                     }}
                   >
                  
                     {message ? {message} : 
                        <>
                     <h4>
                       Document Send for signing. Please authorize.
                     </h4>
                     <br />
                     <CircularProgresss />
                     <br />
                     <h6>Do Not refresh this screen.</h6>
           
                     </>
           }
                   </GridItem>
                   }
                   </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                size="small"
                className={classes.nextButton1}
                disabled={callInProgress}
                onClick={() => handleBack()}
              >
                Back
              </Button>
              {status === "DISBURSALTOLMS" ? (
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress}
                  onClick={() => proceedApplication()}
                >
                  Submit
                </Button>
              ) : (
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress}
                  onClick={() => handleNext()}
                >
                  Next
                </Button>
              )}
            </GridItem>
          </GridContainer>
        </GridItem>
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
          {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {confirmationModal && (
          <ConfirmationModal
            confirmationModal={confirmationModal}
            confirmationModalHeader={confirmationModalHeader}
            confirmationModalMsg={confirmationModalMsg}
            handleNegativeButton={handleNegativeResponse}
            handlePositiveButton={handlePositiveResponse}
            classes={classes}
          />
        )}
      </GridContainer>
    </div>
  );
};

UploadedBtKit.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
  status: PropTypes.object,
};

export default UploadedBtKit;